import { render } from "./TrashButton.vue?vue&type=template&id=2df17ac6"
import script from "./TrashButton.vue?vue&type=script&lang=js"
export * from "./TrashButton.vue?vue&type=script&lang=js"
script.render = render

export default script